export default "__VITE_ASSET__CMNJbUv7__"